import { uspcrmAxiosInstance } from 'axiosintance';

const fetch_all_active_services = async (payload) => {

   

   try {
      const response = await uspcrmAxiosInstance.get(
         `api/subscription/usp_subscriptions/?customerId=${payload}&listType=active`
      );

      return {
         data: response?.data?.data || [],
         pagination: response?.data?.pagination || {},
      };
   } catch (error) {
      console.error("Error fetching active services:", error);
      return {
         data: [],
         pagination: {},
      };
      }   }

export default {
   fetch_all_active_services,
};
